export default __webpack_public_path__ + "static/2_30-f9e5e6bf19a204406259698d0404b911.png";